export default {
  en: {
    TellerTodayHandled: {
      title: "Today's confirmed",
    },
  },
};
